<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">ইউজার ম্যানেজমেন্ট</h1>
        <p class="page-subtitle bangla-text">ইউজার তৈরি করুন এবং ভূমিকা পরিচালনা করুন</p>
      </div>
    </div>
  </div>

  <!-- User Form Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-user-plus"></i>
        {{ isEditing ? 'ইউজার সম্পাদনা' : 'নতুন ইউজার এন্ট্রি' }}
      </h3>
    </div>
    
    <div class="card-body">
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="modern-form">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label bangla-label required">ইউজারনেম *</label>
            <input 
              type="text" 
              class="form-control-modern" 
              formControlName="username" 
              placeholder="ইউজারনেম">
            <div *ngIf="userForm.get('username')?.invalid && userForm.get('username')?.touched" 
                 class="form-error">
              <small *ngIf="userForm.get('username')?.errors?.['required']">ইউজারনেম প্রয়োজন</small>
              <small *ngIf="userForm.get('username')?.errors?.['minlength']">ইউজারনেম কমপক্ষে ৩ অক্ষর হতে হবে</small>
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label bangla-label required">ইমেইল *</label>
            <input 
              type="email" 
              class="form-control-modern" 
              formControlName="email" 
              placeholder="ইমেইল ঠিকানা">
            <div *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched" 
                 class="form-error">
              <small *ngIf="userForm.get('email')?.errors?.['required']">ইমেইল প্রয়োজন</small>
              <small *ngIf="userForm.get('email')?.errors?.['email']">সঠিক ইমেইল ফরম্যাট নয়</small>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="showPasswordField">
          <div class="form-group">
            <label class="form-label bangla-label required">পাসওয়ার্ড *</label>
            <input 
              type="password" 
              class="form-control-modern" 
              formControlName="password" 
              placeholder="পাসওয়ার্ড">
            <div *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched" 
                 class="form-error">
              <small *ngIf="userForm.get('password')?.errors?.['required']">পাসওয়ার্ড প্রয়োজন</small>
              <small *ngIf="userForm.get('password')?.errors?.['minlength']">পাসওয়ার্ড কমপক্ষে ৬ অক্ষর হতে হবে</small>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group full-width">
            <label class="form-label bangla-label">ভূমিকা</label>
            <div class="roles-grid">
              <div class="role-item" *ngFor="let role of availableRoles">
                <label class="role-checkbox">
                  <input 
                    type="checkbox" 
                    [value]="role"
                    [checked]="userForm.get('roles')?.value?.includes(role)"
                    (change)="updateRoleSelection(role)">
                  <span class="role-label">{{ role }}</span>
                  <div class="checkmark">
                    <i class="fas fa-check"></i>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary-modern bangla-text" [disabled]="userForm.invalid">
            <i class="fas fa-save"></i>
            {{ isEditing ? 'আপডেট করুন' : 'দাখিল করুন' }}
          </button>
          <button type="button" class="btn-secondary-modern bangla-text" *ngIf="isEditing" (click)="cancelEdit()">
            <i class="fas fa-times"></i>
            বাতিল
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Users List Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-users"></i>
        ইউজার তালিকা
      </h3>
      <div class="card-actions">
        <span class="data-count bangla-text">
          মোট <strong>{{users?.length || 0}}</strong> জন ইউজার
        </span>
      </div>
    </div>

    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && (!users || users.length === 0)" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-user-slash"></i>
        </div>
        <h3 class="bangla-title">কোন ইউজার পাওয়া যায়নি</h3>
        <p class="bangla-text">এখনো কোন ইউজার তৈরি করা হয়নি। উপরের ফর্ম ব্যবহার করে প্রথম ইউজার তৈরি করুন।</p>
      </div>

      <!-- Users Table -->
      <div *ngIf="!isLoading && users && users.length > 0" class="table-responsive">
        <table class="table-modern" role="table" aria-label="ইউজার তালিকা">
          <thead>
            <tr role="row">
              <th role="columnheader" class="bangla-label">ইউজারনেম</th>
              <th role="columnheader" class="bangla-label">ইমেইল</th>
              <th role="columnheader" class="bangla-label">ভূমিকা</th>
              <th role="columnheader" class="actions-column bangla-label">কার্যক্রম</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of users; let i = index" [class.table-striped]="i % 2 === 0" role="row">
              <td class="username-cell">
                <div class="user-info">
                  <div class="user-avatar">
                    <i class="fas fa-user"></i>
                  </div>
                  <div class="user-details">
                    <span class="username">
                      {{ user.username }}
                      <span *ngIf="isCurrentUser(user)" class="current-user-badge bangla-text" title="আপনি">আপনি</span>
                    </span>
                    <span class="user-id">ID: {{ user.id }}</span>
                  </div>
                </div>
              </td>
              
              <td class="email-cell">
                <span class="email">{{ user.email }}</span>
              </td>
              
              <td class="roles-cell">
                <div class="user-roles">
                  <div class="role-badges">
                    <span class="role-badge" *ngFor="let role of user.roles">{{ role }}</span>
                  </div>
                  <!-- Only show toggle switches when NOT editing this user AND user is not current user -->
                  <div class="role-toggles" *ngIf="(!isEditing || selectedUser?.id !== user.id) && !isCurrentUser(user)">
                    <div class="role-toggle" *ngFor="let role of availableRoles">
                      <label class="toggle-label">
                        <input 
                          type="checkbox" 
                          class="toggle-input"
                          [checked]="hasRole(user, role)"
                          (change)="toggleRole(user, role)">
                        <span class="toggle-switch"></span>
                        <span class="toggle-text">{{ role }}</span>
                      </label>
                    </div>
                  </div>
                  <!-- Show editing indicator when this user is being edited -->
                  <div class="editing-indicator" *ngIf="isEditing && selectedUser?.id === user.id">
                    <i class="fas fa-edit"></i>
                    <span>সম্পাদনা করা হচ্ছে...</span>
                  </div>
                  <!-- Show current user indicator -->
                  <div class="current-user-indicator bangla-text" *ngIf="isCurrentUser(user)">
                    <i class="fas fa-lock"></i>
                    <span>নিজের ভূমিকা পরিবর্তন করা যাবে না</span>
                  </div>
                </div>
              </td>
              
              <td class="actions-cell">
                <div class="action-buttons-cell">
                  <button 
                    type="button"
                    [title]="isCurrentUser(user) ? 'আপনি নিজের একাউন্ট সম্পাদনা করতে পারবেন না' : 'সম্পাদনা করুন'"
                    class="btn-action-sm btn-edit"
                    (click)="editUser(user)"
                    [disabled]="isEditing || isCurrentUser(user)"
                    [attr.aria-label]="'সম্পাদনা করুন ' + user.username">
                    <i class="far fa-edit" aria-hidden="true"></i>
                  </button>
                  
                  <button 
                    type="button"
                    [title]="isCurrentUser(user) ? 'আপনি নিজেকে ডিলিট করতে পারবেন না' : 'ডিলিট করুন'"
                    class="btn-action-sm btn-danger"
                    (click)="deleteUser(user)"
                    [disabled]="isEditing || isCurrentUser(user)"
                    [attr.aria-label]="'ডিলিট করুন ' + user.username">
                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
